<ng-template #loading class="ns-spinner-center">
  <app-ns-spinner></app-ns-spinner>
</ng-template>
<p-messages></p-messages>
<div class="desktop-view" *ngIf="!isMobile">
  <app-top></app-top>
  <app-menu></app-menu>
  <div class="p-d-flex p-flex-column p-ai-center modal-content real-property-agent-profile-container">
    <ng-container *ngIf="agent$ | async as agent; else loading">
      <div class="p-d-flex p-flex-row p-ai-center real-property-agent-basic-info-container">

        <div class="p-d-flex p-ai-center p-jc-center agent-avatar-container">
          <app-avatar [avatarSize]="150" [photoUuid]="agent.photoUuid" [agentName]="agent.name"></app-avatar>
        </div>

        <div class="p-d-flex p-flex-column p-jc-between agent-basic-info-container">

          <div class="agent-name">
            <span>{{agent.name}} {{agent.surname}}</span>
          </div>

          <div class="agent-role">
          <span>
            Эксперт по недвижимости
          </span>
          </div>

          <div class="p-d-flex">
            <div class="tag count">Сделки: {{agent.dealsAllPeriod ?? 0}}</div>
            <ng-template [ngIf]="agent.workExperience">
              <div class="tag experience">{{agent.workExperience}}</div>
            </ng-template>
          </div>

          <div class="p-d-flex p-flex-row p-ai-center rating">

            <ng-template [ngIf]="agent.averageClientRating">
              <div class="p-d-flex p-flex-row p-ai-center agent-rating">
                <div class="rating-icon"></div>
                <span class="average-client-rating">
              {{agent.averageClientRating?.toFixed(1)}}
            </span>
              </div>
            </ng-template>

            <ng-template [ngIf]="agent.agentAchievement">
              <div class="p-d-flex p-flex-row p-ai-center agent-achievement">

                <ng-template [ngIf]="agent.agentAchievement?.achievement?.photoUuid">
                  <div class="achievement-icon">
                    <img [src]="getImageUrl(agent.agentAchievement.achievement.photoUuid)" alt="icon">
                  </div>
                </ng-template>

                <ng-template [ngIf]="agent?.agentAchievement?.achievement">
                <span class="achievement-name">
                  <app-name [name]="agent.agentAchievement.achievement"></app-name>
                </span>
                </ng-template>

              </div>
            </ng-template>

          </div>

          <div class="p-d-flex p-flex-row">

            <ng-template [ngIf]="agent.phoneNumber">
             <a href="tel:+77057559595" class="p-d-flex p-flex-row p-ai-center btn phone">
                <img src="../../assets/images/call-2.svg" alt="call">
                <span>
              <app-phone [phoneNumber]="'7057559595'"></app-phone>
            </span>
              </a>
            </ng-template>

            <ng-template [ngIf]="agent.city">
            <span class="p-d-flex p-flex-row p-ai-center btn city">
              <img src="../../assets/images/location.svg" alt="location">
              <span [title]="agent.city">
                {{agent.city}}
              </span>
            </span>
            </ng-template>

          </div>

        </div>

      </div>

      <ng-template [ngIf]="agent.about">
        <div class="p-d-flex p-flex-column section about-agent">
          <div class="p-d-flex p-flex-row p-ai-center p-jc-between header">
        <span class="p-d-flex p-flex-row p-ai-center title">
          <div class="circle accent">•</div>
          О себе
        </span>
          </div>
          <div class="text">
            {{agent.about}}
          </div>
        </div>
      </ng-template>

      <app-agent-score
              [rating]="agent.rating"
              [averageClientRating]="agent.averageClientRating"
              [agentId]="agent.id">
      </app-agent-score>

      <app-real-property-agent-feedback [agentId]="agent.id"></app-real-property-agent-feedback>

      <app-agent-real-property-list [agentId]="agent.id"></app-agent-real-property-list>

    </ng-container>
  </div>
</div>
<div class="mobile-view" *ngIf="isMobile">
  <ng-container *ngIf="agent$ | async as agent; else loading">
    <div class="agent-header">
      <ng-container *ngIf="agent.photoUuid; else empty">
        <img class="header-background" [src]="getImageUrl(agent.photoUuid)" (error)="onErrorAvatar($event)" [alt]="agent.name">
      </ng-container>
      <ng-template #empty>
        <div class="default-photo header-background">
          <img src="assets/images/User_cicrle_duotone.svg" alt="">
        </div>
      </ng-template>
      <div class="header-info">
        <div class="header-initials">
          <h1>{{agent.name}} <br> {{agent.surname}}</h1>
          <span class="address">Риэлтор - г. {{agent.city}}</span>
        </div>
        <img class="header__star" src="assets/images/star.svg" alt="">
      </div>
    </div>
    <div class="agent-body">
      <p class="position">Топ-лидер</p>
      <div class="agent-controlls">
        <a href="tel:+77057559595" class="agent-button">
          <img src="assets/images/whatsApp-white.svg" alt="">
        </a>
        <a href="https://wa.me/77057559595" class="agent-button green">
          <img src="assets/images/phone-white.svg" alt="">
        </a>
      </div>
      <div class="experience section">
        <p>
          Сделки
          <span class="value">{{agent.dealsAllPeriod}}</span>
        </p>
        <p>
          Опыт
          <span class="value">{{agent.workExperience}}</span>
        </p>
        <p>
          Рейтинг
          <span class="value">
            <img src="assets/images/rating-star-accent-on.svg" alt="">
            {{agent.rating}}
          </span>
        </p>
      </div>
      <div class="about section">
        <h2>О себе</h2>
        {{agent.about}}
      </div>
      <div class="achieves section">
        <app-agent-score
                [rating]="agent.rating"
                [averageClientRating]="agent.averageClientRating"
                [agentId]="agent.id">
        </app-agent-score>
      </div>
      <div class="comments section">
        <app-real-property-agent-feedback [markForUpdate]="markForUpdate" [agentId]="agent.id"></app-real-property-agent-feedback>
      </div>
      <div class="section evaluation">
        <h2>Оцените агента</h2>
        <app-rating-bar (changeRating)="changeRate($event)" class="evaluation-bar" [rating]="chosenRate "></app-rating-bar>
        <div class="sender">
          <h2>Оставьте комментарий:</h2>
          <textarea [formControl]="commentText" class="comment-area" placeholder="Введите текст..."></textarea>
          <button *ngIf="!loadingFlag; else loading" class="comment-button" (click)="onAddFeedback(agent.id)">Оставить отзыв</button>
        </div>

      </div>
      <div class="list section">
        <app-agent-real-property-list [agentId]="agent.id"></app-agent-real-property-list>
      </div>
    </div>
  </ng-container>
</div>